export default __webpack_public_path__ + "static/media/logotipo.2db78d22.svg";